import { buildPageableParams, PageableArgs, servicesApi } from '@common/services';
import { queryUntilLastPage } from '../common/pageable/query-until-last-page';
import { EtablissementFichierProjection } from './enums/etablissement-fichier-projection.enum';
import { EtablissementFichierDto } from './index';

const ETABLISSEMENT_FICHIER_URL_PREFIX = `etablissements-fichiers`;

const etablissementApi = servicesApi.injectEndpoints!({
  endpoints: (build) => ({
    getAllEtablissementsFichiers: build.query<EtablissementFichierDto[], PageableArgs<never>, any>({
      queryFn: (pageable = {}, _api, _extraOptions, baseQuery) => queryUntilLastPage({
        baseQuery,
        url: ETABLISSEMENT_FICHIER_URL_PREFIX,
        params: buildPageableParams(pageable),
      }),
      providesTags: ['EtablissementsFichiers'],
    }),

    getAllEtablissementsFichiersForOrganisme: build.query<EtablissementFichierDto[], PageableArgs<EtablissementFichierProjection>, any>({
      queryFn: (pageable = {}, _api, _extraOptions, baseQuery) => queryUntilLastPage({
        baseQuery,
        url: `${ETABLISSEMENT_FICHIER_URL_PREFIX}/organisme`,
        params: buildPageableParams(pageable),
      }),
    providesTags: ['EtablissementsFichiers'],
    }),
  }),
});

export const {
  useGetAllEtablissementsFichiersQuery,
  useGetAllEtablissementsFichiersForOrganismeQuery,
} = etablissementApi;